var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartnerUnverify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 28,
    viewBox: "0 0 23 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4937 0.178607L1.86875 3.36102C0.7475 3.78535 0 4.83201 0 6.02011V12.6678C0 19.4994 4.49938 25.9208 10.6806 27.8727C11.2125 28.0424 11.7875 28.0424 12.3194 27.8727C18.5006 25.9208 23 19.5136 23 12.6678V6.02011C22.999 5.44453 22.8195 4.88295 22.4856 4.41035C22.1517 3.93775 21.6792 3.57662 21.1312 3.37517L12.5062 0.192751C11.8594 -0.0618424 11.1406 -0.0618424 10.4937 0.178607ZM11.5 21.027C7.5325 21.027 4.3125 17.8587 4.3125 13.9549C4.3125 10.0512 7.5325 6.8829 11.5 6.8829C15.4675 6.8829 18.6875 10.0512 18.6875 13.9549C18.6875 17.8587 15.4675 21.027 11.5 21.027ZM14.375 16.7837C14.0875 17.0666 13.6419 17.0666 13.3544 16.7837L10.9825 14.45C10.8484 14.3185 10.7711 14.1411 10.7669 13.9549V10.4189C10.7812 10.0229 11.0975 9.71171 11.5 9.71171C11.9025 9.71171 12.2187 10.0229 12.2187 10.4189V13.6579L14.375 15.7795C14.6625 16.0624 14.6625 16.5009 14.375 16.7837Z",
    fill: "#979797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerUnverify);
export default __webpack_public_path__ + "static/media/partner_unverify.33ad103cc5b2b5dadcdd0006b7181ed7.svg";
export { ForwardRef as ReactComponent };